<template>
  <RefPayoutBody/>
</template>

<script>
// @ is an alias to /src
import RefPayoutBody from '@/components/RefPayoutBody.vue'

export default {
  name: 'RefPayoutView',
  components: {
    RefPayoutBody
  }
}
</script>
